// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__36nMx","active":"downloadDropdown_active__ZG5CL"};